import "core-js/modules/es6.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Feature from 'src/store/models/Feature';
export default {
  props: {
    feature: {
      type: String,
      required: true
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '18px'
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Array,
      default: function _default() {
        return [7, 5];
      }
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },
  computed: {
    subscriptionTypes: function subscriptionTypes() {
      var feature = Feature.find(this.feature);
      return feature && feature.subscription_types ? feature.subscription_types : [];
    },
    isVisible: function isVisible() {
      return !this.me.account.hasFeatureAccess(this.feature);
    },
    subscriptionTypeString: function subscriptionTypeString() {
      var recommendedType = this.subscriptionTypes.reduce(function (prev, current) {
        return current.is_old || prev.tier < current.tier ? prev : current;
      }, {});
      return this.$tc('components.subscriptionTypeUpgrade.' + recommendedType.slug);
    }
  },
  methods: {
    onClick: function onClick() {
      if (this.me.is_owner) {
        this.$router.push('/billing');
      } else {
        this.openDialog('UserConfirmationDialog', {
          html: true,
          title: '',
          message: "\n            <div class=\"column q-my-lg q-mx-md text-center\">\n              <div class=\"text-h6 q-mb-md bold\">\n                ".concat(this.$tc('components.subscriptionTypeUpgrade.not_owner'), "\n              </div>\n              <div class=\"text-body1\">\n                ").concat(this.$tc('components.subscriptionTypeUpgrade.not_owner_message'), "\n              </div>\n            </div>\n          "),
          withoutHeader: true,
          withoutFooter: true
        });
      }
    },
    showTooltip: function showTooltip() {
      this.$refs.tooltip.show();
    }
  }
};